const DeleteIcon = () => {
	return (
		<svg
			width="32"
			height="36"
			viewBox="0 0 32 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.05 36C4.21667 36 3.50833 35.7083 2.925 35.125C2.34167 34.5417 2.05 33.8333 2.05 33V4.5H0V1.5H9.4V0H22.6V1.5H32V4.5H29.95V33C29.95 33.8 29.65 34.5 29.05 35.1C28.45 35.7 27.75 36 26.95 36H5.05ZM26.95 4.5H5.05V33H26.95V4.5ZM10.35 28.7H13.35V8.75H10.35V28.7ZM18.65 28.7H21.65V8.75H18.65V28.7ZM5.05 4.5V33V4.5Z"
				fill="#64648C"
			/>
		</svg>
	);
};

export default DeleteIcon;
